<template>
  <section :class="$style.modal">
    <slot name="header" />
    <div v-if="loading" :class="[$style.modal__loading, $style.loading]">
      <LoadingIndicator :class="$style.loading__indicator" />
    </div>
    <div v-else :class="[$style.content, $style.modal__content]">
      <div :class="[$style.content__list, $style.list]" v-if="slots.list">
        <p v-if="noTemplate" :class="$style.list__empty">
          テンプレートがありません
        </p>
        <div :class="$style.list__content" v-else>
          <slot name="list" />
        </div>
      </div>
      <div :class="[$style.content__detail, $style.detail]" v-if="slots.detail">
        <slot name="detail" />
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { useSlots } from 'vue'
import LoadingIndicator from '@/components/atoms/LoadingIndicator.vue'

withDefaults(defineProps<{ loading?: boolean; noTemplate?: boolean }>(), {
  loading: false,
  noTemplate: false,
})
const slots = useSlots()
</script>

<style lang="scss" module>
.modal {
  display: flex;
  flex-direction: column;
  border-radius: $border-radius-v2-rounder;
  background-color: $color-surface-primary;
  width: 800px;
  height: 600px;
  max-height: 80vh;

  &__content {
    height: 100%;
  }

  &__loading {
    place-content: center center;
  }
}

.loading {
  display: flex;
  place-content: center center;
  height: 100%;

  &__indicator {
    flex: 0 0 auto;
  }
}

.content {
  display: flex;
  border-top: 1px $color-border-low-emphasis solid;
  padding: 20px 20px 24px;
  overflow-y: hidden;

  &__list {
    flex-basis: 200px;
    flex-shrink: 0;
  }

  &__detail {
    flex-grow: 1;

    &:nth-child(n + 2) {
      padding-left: 16px;
      border-left: solid 1px $color-border-low-emphasis;
    }
  }
}

.list {
  overflow-y: scroll;

  &__empty {
    font-weight: bold;
  }

  &__content {
    height: 100%;
  }
}

.detail {
  display: flex;
  justify-content: stretch;

  > * {
    flex: 1;
  }
}
</style>
